import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAPI, postAPI } from "../../service/http-service";
import { ReportEndpoint } from "../../service/endpointConfig/ReportEndpoint";

let initialState: any = {
  ReportResponse: {},
};

export const ReportService = createAsyncThunk(
  "manageReport/report",
  async (report: any) => {
    try {
      let response;
      switch (report.apiAction) {
        case "history":
          response = await getAPI(ReportEndpoint.reportHistory);
          break;
        case "downloadFromHistory":
          response = await getAPI(
            `${ReportEndpoint.downloadFromHistory}/${report.formValues}`
          );
          break;
        case "certificateReportStudentAndLevelWise":
          response = await postAPI(
            ReportEndpoint.certificateReportStudentAndLevelWise,
            report.formValues
          );
          break;
        case "certificateStatusReport":
          response = await postAPI(
            ReportEndpoint.certificateStatusReport,
            report.formValues
          );
          break;
        case "ciWiseDropoutCount":
          response = await postAPI(
            ReportEndpoint.ciWiseDropoutCount,
            report.formValues
          );
          break;
        case "userLoginDetails":
          response = await postAPI(
            ReportEndpoint.userLoginDetails,
            report.formValues
          );
          break;
        case "franchiseeAttendanceTracker":
          response = await postAPI(
            ReportEndpoint.franchiseeAttendanceTracker,
            report.formValues
          );
          break;
        case "rejoineeTrackerTrend":
          response = await postAPI(
            ReportEndpoint.rejoineeTrackerTrend,
            report.formValues
          );
          break;
        case "franchiseeDetails":
          response = await postAPI(
            ReportEndpoint.franchiseeDetails,
            report.formValues
          );
          break;
        case "franchiseeWiseDropoutReport":
          response = await postAPI(
            ReportEndpoint.franchiseeWiseDropoutReport,
            report.formValues
          );
          break;
        case "STReport":
          response = await postAPI(ReportEndpoint.STReport, report.formValues);
          break;
        case "kitSaleIndex":
          response = await postAPI(
            ReportEndpoint.kitSaleIndex,
            report.formValues
          );
          break;
        case "kitMovementReport":
          response = await postAPI(
            ReportEndpoint.kitMovementReport,
            report.formValues
          );
          break;
        case "monthWiseRoyalty":
          response = await postAPI(
            ReportEndpoint.monthWiseRoyalty,
            report.formValues
          );
          break;
        case "netActiveStudent":
          response = await postAPI(
            ReportEndpoint.netActiveStudent,
            report.formValues
          );
          break;
        case "netActiveStudentChannel":
          response = await postAPI(
            ReportEndpoint.netActiveStudentChannel,
            report.formValues
          );
          break;
        case "newFranchiseeGrowthReport":
          response = await postAPI(
            ReportEndpoint.newFranchiseeGrowthReport,
            report.formValues
          );
          break;
        case "poReport":
          response = await postAPI(ReportEndpoint.poReport, report.formValues);
          break;
        case "feedback":
          response = await postAPI(ReportEndpoint.feedback, report.formValues);
          break;
        case "prodigyMetricData":
          response = await postAPI(
            ReportEndpoint.prodigyMetricData,
            report.formValues
          );
          break;
        case "purchaseReturn":
          response = await postAPI(
            ReportEndpoint.purchaseReturn,
            report.formValues
          );
          break;
        case "sipBrandPromise":
          response = await postAPI(
            ReportEndpoint.sipBrandPromise,
            report.formValues
          );
          break;
        case "stockSoldAndStockOrderedForHigherLevel":
          response = await postAPI(
            ReportEndpoint.stockSoldAndStockOrderedForHigherLevel,
            report.formValues
          );
          break;
        case "stockSoldAndStockOrderedForRegistrationKit":
          response = await postAPI(
            ReportEndpoint.stockSoldAndStockOrdered,
            report.formValues
          );
          break;
        case "studentAdmissionChannal":
          response = await postAPI(
            ReportEndpoint.studentAdmissionChannal,
            report.formValues
          );
          break;
        case "studentAdmission":
          response = await postAPI(
            ReportEndpoint.studentAdmission,
            report.formValues
          );
          break;
        case "studentComplete":
          response = await postAPI(
            ReportEndpoint.studentComplete,
            report.formValues
          );
          break;
        case "studentDiscontinue":
          response = await postAPI(
            ReportEndpoint.studentDiscontinue,
            report.formValues
          );
          break;
        case "studentHistory":
          response = await postAPI(
            ReportEndpoint.studentHistory,
            report.formValues
          );
          break;
        case "studentLeadDetailed":
          response = await postAPI(
            ReportEndpoint.studentLeadDetailed,
            report.formValues
          );
          break;
        case "studentRedeemHistory":
          response = await postAPI(
            ReportEndpoint.studentRedeemHistory,
            report.formValues
          );
          break;
        case "studentWiseRoyalty":
          response = await postAPI(
            ReportEndpoint.studentWiseRoyalty,
            report.formValues
          );
          break;
        case "competitionParticipantStudentNational":
          response = await postAPI(
            ReportEndpoint.competitionParticipantStudentNational,
            report.formValues
          );
          break;
        case "competitionParticipantStudentRegional":
          response = await postAPI(
            ReportEndpoint.competitionParticipantStudentRegional,
            report.formValues
          );
          break;
        case "kolorChampReportNational":
          response = await postAPI(
            ReportEndpoint.nationalKolorChamp,
            report.formValues
          );
          break;
        case "kolorChampReportRegional":
          response = await postAPI(
            ReportEndpoint.regionalKolorChamp,
            report.formValues
          );
          break;
        case "studentLevelDurationReportStudentWise":
          response = await postAPI(
            ReportEndpoint.studentLevelDurationReportStudentWise,
            report.formValues
          );
          break;
        case "studentLevelDurationReportFranchiseeWise":
          response = await postAPI(
            ReportEndpoint.studentLevelDurationReportFranchiseeWise,
            report.formValues
          );
          break;
        case "stockSoldAndStockOrderedForHigherLevelChannel":
          response = await postAPI(
            ReportEndpoint.stockSoldAndStockOrderedForHigherLevelChannel,
            report.formValues
          );
          break;
        case "studentInformationReport":
          response = await postAPI(
            ReportEndpoint.studentInformationReport,
            report.formValues
          );
          break;
        case "netStudentVsReceiptReport":
          response = await postAPI(
            ReportEndpoint.netStudentsVsReceiptsHo,
            report.formValues
          );
          break;
        case "myBusinessTrackerReport":
          response = await postAPI(
            ReportEndpoint.myBusinessTrackerReport,
            report.formValues
          );
          break;
        case "monthwiseRoyaltyReport":
          response = await postAPI(
            ReportEndpoint.monthwiseRoyaltyReport,
            report.formValues
          );
          break;
        case "BusinessTrackerPlusandNonPlusReport":
          response = await postAPI(
            ReportEndpoint.BusinessTrackerPlusandNonPlusReport,
            report.formValues
          );
          break;
        case "BusinessTrackerPlus":
          response = await postAPI(
            ReportEndpoint.BusinessTrackerPlus,
            report.formValues
          );
          break;
        case "paymentReport":
          response = await postAPI(
            ReportEndpoint.paymentReport,
            report.formValues
          );
          break;
        case "GSTReport":
          response = await postAPI(ReportEndpoint.gstReport, report.formValues);
          break;
        case "studentwiseRoyaltyFeeReport":
          response = await postAPI(
            ReportEndpoint.studentwiseRoyaltyFeeReport,
            report.formValues
          );
          break;
        case "studentBirthdayReport":
          response = await getAPI(ReportEndpoint.studentBirthdayReport);
          break;
        case "studentReceiptReport":
          response = await postAPI(
            ReportEndpoint.studentReceiptReport,
            report.formValues
          );
          break;
        case "zohoCRM":
          response = await postAPI(
            ReportEndpoint.zohoCRMLeadReport,
            report.formValues
          );
          break;
      }
      return response;
    } catch (err) {
      return err;
    }
  }
);

const ReportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    addObj: (state, action: any) => {
      state.entity.push({ success: false });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(ReportService.fulfilled, (state, action) => {
      state.ReportResponse = action.payload;
    });
    builder.addCase(ReportService.rejected, (state, action) => {
      if (action.payload) {
        state.entity = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const ReportReducer = ReportSlice.reducer;
export default ReportReducer;
